import { fetcher } from "@api/_base";
import { BrandHeaderResponse } from "@interfaces/dto/brands.dto";
import useSWR from "swr";

export const useBrandHeader = (
    brandId: string | undefined
  ): BrandHeaderResponse => {
    const { data, error, mutate } = useSWR(
        brandId ? `/nextapi/brand/${brandId}` : undefined,
      fetcher
    );
  
    return {
      data: data && data.length > 0 ? data[0] : undefined,
      isLoading: !error && !data,
      error: error,
      mutate: mutate,
    };
  };